import { createStoreSelector } from "../selectors";
export const selectFaq = (state) => createStoreSelector(state, 'faq')(state);
//# sourceMappingURL=faq.selectors.js.map